var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrashCan = function SvgTrashCan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M17.5 4.983a84.752 84.752 0 0 0-8.35-.417c-1.65 0-3.3.084-4.95.25l-1.7.167M7.082 4.142l.183-1.092C7.4 2.26 7.5 1.667 8.907 1.667h2.183c1.409 0 1.517.625 1.642 1.392l.183 1.083M15.71 7.617l-.542 8.392c-.092 1.308-.167 2.325-2.492 2.325h-5.35c-2.325 0-2.4-1.017-2.491-2.325l-.542-8.392M8.607 13.75h2.775M7.918 10.417h4.167"
  })));
};
export default SvgTrashCan;